import React from 'react';
import { AdminRouteName } from '../../../CONSTANTS';
import TransactionTableRecords from '../TransactionTableRecord';

const PendingTransaction = () => (
  <div className="transaction-root-cover"><TransactionTableRecords hasNameAndImage defaultUrl={AdminRouteName.pendingTransactionRoute} tabStatus="pending" toggleStorageId="pending-transaction-table-col" recordPermission="can-view-pending-transaction" /></div>
);
export default PendingTransaction;
